var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ranges"},[(_vm.ranges)?_c('ul',_vm._l((_vm.ranges),function(value,key){return _c('li',{key:key,class:_vm.range_class(value),attrs:{"data-range-key":key},on:{"click":function($event){return _vm.$emit('clickRange', value)}}},[_vm._v(_vm._s(key)+" ")])}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }